<div fxShow fxHide.gt-sm class="footer">

  <div>
    <button mat-icon-button class="back" (click)="this.goBack.emit()">
      <mat-icon svgIcon="back"></mat-icon>
    </button>
  </div>

  <ng-content></ng-content>

</div>
